import styled from 'styled-components';

export const ContentWrapper = styled.div`
  position: absolute;
  box-sizing: border-box;
  z-index: 10;

  display: flex;
  align-items: center;

  margin-top: 5px;
  left: ${p => p.leftOffset ? p.leftOffset + 'px' : 'unset'};
  right: ${p => p.leftOffset ? 'unset' : p.leftOffset + 'px'};
`;
